import React ,{useState} from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Modal,Tabs,Col,Row } from "react-bootstrap";
import BotImageUpload from "./BotImageUpload";
import BotImageTemplateLibrary from "./BotImageTemplateLibrary";
import {setLibraryImageSelect,setImageSelect } from "../../../actions/image-upload-action";


const BotImageUploadView = (props)=>{
    const imgSelected =  useSelector((state) => state.newTemplate.selectLibraryImage)
    const imgUploaded =  useSelector((state) => state.newTemplate.uploadPreview)
    const dispatch = useDispatch();
    const {
        onHide,
        setLibraryImageSelect,
        setImageSelect
    }=props;
    
    const show =  useSelector((state) => state.newTemplate.show)
    
    const [activeTab, setActiveTab] = useState(0);
    const tabTitles = ["Upload", "Chose From Template Library"];
    const tabHeaders = tabTitles.map((item, index) => {
        return (
        <Col xs={4} key={index}>
            <a
            onClick={() => setActiveTab(index)}
            className={index == activeTab ? "tab-active" : "tab-inactive"}
            >
            {item}
            </a>
        </Col>
        );
    });
    const tabs = [
        <BotImageUpload  />,
        <BotImageTemplateLibrary/>,
    ];
    return (
        <>
        <Modal show={show} onHide={onHide} size="xl" dialogClassName="test" enforceFocus={false}>
            <Modal.Header closeButton className="align-items-center no-bottom-border">
            </Modal.Header>
            <Modal.Body style={{ minHeight: "600px" }}>
            <Row>{tabHeaders}</Row>
                {tabs[activeTab]}
            </Modal.Body>
            <Modal.Footer className="flex-start">
                <button className="btn btn-primary mr-2" onClick={()=>{activeTab==1?setLibraryImageSelect(imgSelected):setImageSelect(imgUploaded)}}>Select</button>
                <button className="btn btn-outline-secondary mr-3" onClick={onHide}>Cancel</button>
            </Modal.Footer>
        </Modal>
        </>
    )
}
export default connect(null,{setImageSelect,setLibraryImageSelect})(BotImageUploadView);